<div class="wizard-container p-6 w-full">
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>
  <!-- Content -->
  <div class="step-content">
    <!-- ================= STEP 1 ================= -->
    @if (wizardStepService.currentStep() === 0) {
      <!-- Breadcrumb navigation (WCAG 9.3.2.3: Consistent Navigation) -->
      <nav class="mb-3" aria-label="Breadcrumb">
        <p-breadcrumb
          styleClass="custom-breadcrumb"
          [model]="breadcrumbItems"
          [home]="{ icon: 'pi pi-home', routerLink: '/axa/suppliers-dashboard', ariaLabel: 'Home' }"
        ></p-breadcrumb>
      </nav>

      <!-- Page Header -->
      <section class="page-header mb-5" aria-labelledby="page-heading">
        <div class="header-content">
          <div class="header-left">
            <i class="pi pi-building header-icon" aria-hidden="true"></i>
            <div class="header-text">
              <h1 id="page-heading">Inserimento Anagrafica Fornitore</h1>
              <p class="subtitle">Inserisci i dati anagrafici completi del nuovo fornitore</p>
            </div>
          </div>
        </div>
      </section>

      <form [formGroup]="step1Form" (ngSubmit)="saveStep1AndContinue()" class="p-fluid">
        <!-- Sezione Dati Anagrafici -->
        <section
          class="surface-0 border-round p-5 mb-4 shadow-1"
          aria-labelledby="dati-anagrafici-heading"
        >
          <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
            <i class="pi pi-user text-2xl section-icon" aria-hidden="true"></i>
            <h2 id="dati-anagrafici-heading" class="text-xl font-semibold m-0 section-title">
              Dati Anagrafici
            </h2>
          </div>

          <div class="grid">
            <div class="field col-12 md:col-6">
              <label for="alternativeName" class="font-semibold block mb-2"
                >Denominazione commerciale</label
              >
              <input
                pInputText
                id="alternativeName"
                formControlName="alternativeName"
                class="w-full"
                placeholder="Nome commerciale alternativo"
                aria-label="Denominazione commerciale"
                [attr.aria-invalid]="
                  step1Form.get('alternativeName')?.invalid && step1Form.get('alternativeName')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('alternativeName')?.invalid && step1Form.get('alternativeName')?.touched
                    ? 'alternativeName-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('alternativeName')" 
                errorId="alternativeName-error"
                mode="strict"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="personType" class="font-semibold block mb-2"
                >Persona Fisica / Giuridica
                <span class="required-marker" aria-hidden="true">*</span></label
              >
              <p-select
                inputId="personType"
                [options]="personTypeOptions"
                formControlName="personType"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleziona tipo persona"
                styleClass="w-full"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  step1Form.get('personType')?.invalid && step1Form.get('personType')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('personType')?.invalid && step1Form.get('personType')?.touched
                    ? 'personType-error'
                    : null
                "
              >
              </p-select>
              <app-validation-error 
                [control]="step1Form.get('personType')" 
                errorId="personType-error"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="supplierName" class="font-semibold block mb-2"
                >Ragione Sociale <span class="required-marker" aria-hidden="true">*</span></label
              >
              <input
                pInputText
                id="supplierName"
                formControlName="supplierName"
                class="w-full"
                placeholder="Es: Azienda"
                aria-required="true"
                [attr.aria-invalid]="
                  step1Form.get('supplierName')?.invalid && step1Form.get('supplierName')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('supplierName')?.invalid && step1Form.get('supplierName')?.touched
                    ? 'supplierName-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('supplierName')" 
                errorId="supplierName-error"
                mode="strict"
              />
              <small class="block mt-1 text-600">Non inserire il tipo di società</small>
            </div>

            <div class="field col-12 md:col-6">
              <label for="supplierTypeId" class="font-semibold block mb-2"
                >Tipo Società <span class="required-marker" aria-hidden="true">*</span></label
              >
              <p-select
                inputId="supplierTypeId"
                [options]="filteredSupplierTypes()"
                formControlName="supplierTypeId"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona tipo società"
                [filter]="true"
                [showClear]="true"
                styleClass="w-full"
                [attr.aria-required]="true"
                [attr.aria-disabled]="!step1Form.get('personType')?.value"
                [attr.aria-invalid]="
                  step1Form.get('supplierTypeId')?.invalid &&
                  step1Form.get('supplierTypeId')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('supplierTypeId')?.invalid &&
                  step1Form.get('supplierTypeId')?.touched
                    ? 'supplierTypeId-error'
                    : null
                "
              >
              </p-select>
              <app-validation-error 
                [control]="step1Form.get('supplierTypeId')" 
                errorId="supplierTypeId-error"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="vatCountry" class="font-semibold block mb-2">
                Paese partita IVA <span class="required-marker" aria-hidden="true">*</span>
              </label>
              <p-select
                inputId="vatCountry"
                formControlName="vatCountry"
                [options]="vatCountryOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                [filter]="true"
                filterBy="valueDescription,valueKey"
                styleClass="w-full"
                placeholder="Seleziona paese IVA"
                ariaLabel="Paese partita IVA"
                [attr.aria-required]="true"
                [attr.aria-invalid]="step1Form.get('vatCountry')?.invalid && step1Form.get('vatCountry')?.touched"
                [attr.aria-describedby]="legacyVatCountry() ? 'vatCountry-legacy vatCountry-error' : 'vatCountry-error'"
              />
              @if (legacyVatCountry()) {
                <small id="vatCountry-legacy" class="block mt-1">
                  Fornitore registrato senza paese della partita IVA: seleziona il paese e inserisci la partita IVA senza prefisso.
                </small>
              }
              <app-validation-error [control]="step1Form.get('vatCountry')" errorId="vatCountry-error" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="vatNumber" class="font-semibold block mb-2">
                Partita IVA
                @if (step1Form.get('personType')?.value === 'LEGAL_ENTITY') {
                  <span class="required-marker" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="vatNumber"
                formControlName="vatNumber"
                class="w-full"
                [placeholder]="vatNumberHint"
                [maxlength]="vatNumberMaxLength"
                [attr.aria-required]="step1Form.get('personType')?.value === 'LEGAL_ENTITY'"
                [attr.aria-invalid]="
                  step1Form.get('vatNumber')?.invalid && step1Form.get('vatNumber')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('vatNumber')?.invalid && step1Form.get('vatNumber')?.touched
                    ? 'vatNumber-error'
                    : 'vatNumber-hint'
                "
              />
              <small id="vatNumber-hint" class="block mt-1">Senza prefisso paese. {{ vatNumberHint }}.</small>
              <app-validation-error 
                [control]="step1Form.get('vatNumber')" 
                errorId="vatNumber-error"
                [vatNumberMessage]="'Partita IVA non valida. ' + vatNumberHint + ', senza prefisso paese.'"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="fiscalCode" class="font-semibold block mb-2"
                >Codice Fiscale <span class="required-marker" aria-hidden="true">*</span></label
              >
              <input
                pInputText
                id="fiscalCode"
                formControlName="fiscalCode"
                class="w-full"
                placeholder="16 caratteri (persone fisiche) o 11 cifre (persone giuridiche)"
                aria-required="true"
                [attr.aria-invalid]="
                  step1Form.get('fiscalCode')?.invalid && step1Form.get('fiscalCode')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('fiscalCode')?.invalid && step1Form.get('fiscalCode')?.touched
                    ? 'fiscalCode-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('fiscalCode')" 
                errorId="fiscalCode-error"
                mode="alphanumeric"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="primaryEmail" class="font-semibold block mb-2">Email ordinaria</label>
              <input
                pInputText
                id="primaryEmail"
                formControlName="primaryEmail"
                type="email"
                class="w-full"
                placeholder="nome@esempio.it"
                aria-label="Email ordinaria"
                [attr.aria-invalid]="
                  step1Form.get('primaryEmail')?.invalid && step1Form.get('primaryEmail')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('primaryEmail')?.invalid && step1Form.get('primaryEmail')?.touched
                    ? 'primaryEmail-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('primaryEmail')" 
                errorId="primaryEmail-error"
                mode="strict"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="emailPEC" class="font-semibold block mb-2">Email PEC</label>
              <input
                pInputText
                id="emailPEC"
                formControlName="certifiedEmail"
                type="email"
                class="w-full"
                placeholder="nome@pec.it"
                aria-label="Email PEC"
                [attr.aria-invalid]="
                  step1Form.get('certifiedEmail')?.invalid &&
                  step1Form.get('certifiedEmail')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('certifiedEmail')?.invalid &&
                  step1Form.get('certifiedEmail')?.touched
                    ? 'emailPEC-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('certifiedEmail')" 
                errorId="emailPEC-error"
                mode="strict"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="contactPerson" class="font-semibold block mb-2">Nome del Referente</label>
              <input
                pInputText
                id="contactPerson"
                formControlName="contactPerson"
                class="w-full"
                placeholder="Nome e cognome del referente"
                aria-label="Nome del Referente"
                [attr.aria-invalid]="
                  step1Form.get('contactPerson')?.invalid && step1Form.get('contactPerson')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('contactPerson')?.invalid && step1Form.get('contactPerson')?.touched
                    ? 'contactPerson-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('contactPerson')" 
                errorId="contactPerson-error"
                mode="name"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="telephoneNumber" class="font-semibold block mb-2">Telefono</label>
              <input
                pInputText
                id="telephoneNumber"
                formControlName="telephoneNumber"
                class="w-full"
                placeholder="+39 0123456789"
                aria-label="Telefono"
                [attr.aria-invalid]="
                  step1Form.get('telephoneNumber')?.invalid &&
                  step1Form.get('telephoneNumber')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('telephoneNumber')?.invalid &&
                  step1Form.get('telephoneNumber')?.touched
                    ? 'telephoneNumber-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('telephoneNumber')" 
                errorId="telephoneNumber-error"
                mode="strict"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="mobileNumber" class="font-semibold block mb-2">Mobile</label>
              <input
                pInputText
                id="mobileNumber"
                formControlName="mobileNumber"
                class="w-full"
                placeholder="+39 3XX XXXXXXX"
                aria-label="Mobile"
                [attr.aria-invalid]="
                  step1Form.get('mobileNumber')?.invalid && step1Form.get('mobileNumber')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('mobileNumber')?.invalid && step1Form.get('mobileNumber')?.touched
                    ? 'mobileNumber-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('mobileNumber')" 
                errorId="mobileNumber-error"
                mode="strict"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="axaBuyer" class="font-semibold block mb-2">
                Buyer AXA <span class="required-marker" aria-hidden="true">*</span>
              </label>
              <input
                pInputText
                id="axaBuyer"
                formControlName="axaBuyer"
                class="w-full"
                placeholder="Nome e Cognome"
                aria-required="true"
                [attr.aria-invalid]="
                  step1Form.get('axaBuyer')?.invalid && step1Form.get('axaBuyer')?.touched
                "
                [attr.aria-describedby]="
                  step1Form.get('axaBuyer')?.invalid && step1Form.get('axaBuyer')?.touched
                    ? 'axaBuyer-error'
                    : null
                "
              />
              <app-validation-error 
                [control]="step1Form.get('axaBuyer')" 
                errorId="axaBuyer-error"
                mode="name"
              />
            </div>
          </div>
        </section>

        <!-- Sezione Indirizzo Sede Legale -->
        <section
          class="surface-0 border-round p-5 mb-4 shadow-1"
          aria-labelledby="indirizzo-heading"
        >
          <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
            <i class="pi pi-map-marker text-2xl section-icon" aria-hidden="true"></i>
            <h2 id="indirizzo-heading" class="text-xl font-semibold m-0 section-title">
              Indirizzo Sede Legale
            </h2>
          </div>

          <div formArrayName="addresses" class="grid">
            <ng-container formGroupName="0">
              <div class="field col-12 md:col-6">
                <label for="addressTypology" class="font-semibold block mb-2">Toponimo</label>
                <p-select
                  inputId="addressTypology"
                  [options]="addressTypologyOptions()"
                  formControlName="typology"
                  optionLabel="valueDescription"
                  optionValue="valueKey"
                  placeholder="Seleziona toponimo"
                  styleClass="w-full"
                  [filter]="true"
                  filterPlaceholder="Cerca toponimo"
                  aria-label="Toponimo indirizzo"
                >
                </p-select>
              </div>
              <div class="field col-12 md:col-6">
                <label for="addressName" class="font-semibold block mb-2">Indirizzo</label>
                <input
                  pInputText
                  id="addressName"
                  formControlName="address"
                  class="w-full"
                  placeholder="Nome della strada"
                  aria-label="Nome della strada"
                  [attr.aria-invalid]="
                    getAddressGroup(0)?.get('address')?.invalid &&
                    getAddressGroup(0)?.get('address')?.touched
                  "
                  [attr.aria-describedby]="
                    getAddressGroup(0)?.get('address')?.invalid &&
                    getAddressGroup(0)?.get('address')?.touched
                      ? 'addressName-error'
                      : null
                  "
                />
                <app-validation-error 
                  [control]="getAddressGroup(0)?.get('address') || null" 
                  errorId="addressName-error"
                  mode="address"
                />
              </div>

              <div class="field col-12 md:col-6">
                <label for="civico" class="font-semibold block mb-2">Civico</label>
                <input
                  id="civico"
                  pInputText
                  formControlName="number"
                  class="w-full"
                  placeholder="Numero civico"
                  aria-label="Numero civico"
                />
              </div>


              <div class="field col-12 md:col-6">
                <label for="zipCode" class="font-semibold block mb-2">CAP/Postal Code</label>
                <input
                  pInputText
                  id="zipCode"
                  formControlName="zipCode"
                  class="w-full"
                  placeholder="Inserisci CAP o codice postale"
                  aria-label="CAP o Postal Code"
                  [attr.aria-invalid]="
                    getAddressGroup(0)?.get('zipCode')?.invalid &&
                    getAddressGroup(0)?.get('zipCode')?.touched
                  "
                  [attr.aria-describedby]="
                    getAddressGroup(0)?.get('zipCode')?.invalid &&
                    getAddressGroup(0)?.get('zipCode')?.touched
                      ? 'zipCode-error'
                      : null
                  "
                />
                <app-validation-error 
                  [control]="getAddressGroup(0)?.get('zipCode') || null" 
                  errorId="zipCode-error"
                  mode="alphanumeric"
                />
              </div>

              <div class="field col-12 md:col-6">
                <label for="region" class="font-semibold block mb-2">Regione</label>
                @if (isItalySelected()) {
                  <p-select
                    inputId="region"
                    [options]="regionOptions()"
                    formControlName="region"
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Seleziona regione"
                    styleClass="w-full"
                    [filter]="true"
                    filterPlaceholder="Cerca regione"
                    showClear="true"
                    aria-label="Regione"
                  >
                  </p-select>
                } @else {
                  <input
                    pInputText
                    id="region"
                    formControlName="region"
                    class="w-full"
                    placeholder="Inserisci regione/stato"
                    aria-label="Regione o stato"
                    [attr.aria-invalid]="
                      getAddressGroup(0)?.get('region')?.invalid &&
                      getAddressGroup(0)?.get('region')?.touched
                    "
                    [attr.aria-describedby]="
                      getAddressGroup(0)?.get('region')?.invalid &&
                      getAddressGroup(0)?.get('region')?.touched
                        ? 'region-error'
                        : null
                    "
                  />
                  <app-validation-error 
                    [control]="getAddressGroup(0)?.get('region') || null" 
                    errorId="region-error"
                    mode="address"
                  />
                }
              </div>

              <div class="field col-12 md:col-6">
                <label for="province" class="font-semibold block mb-2">Provincia</label>
                @if (isItalySelected()) {
                  <p-select
                    inputId="province"
                    [options]="provinceOptions()"
                    formControlName="province"
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Seleziona provincia"
                    styleClass="w-full"
                    [filter]="true"
                    filterPlaceholder="Cerca provincia"
                    showClear="true"
                    aria-label="Provincia"
                    [attr.aria-disabled]="isProvinceDisabled()"
                  >
                  </p-select>
                  @if (isProvinceDisabled()) {
                    <small class="text-color-secondary">Seleziona prima la regione</small>
                  }
                } @else {
                  <input
                    pInputText
                    id="province"
                    formControlName="province"
                    class="w-full"
                    placeholder="Inserisci provincia/contea"
                    aria-label="Provincia o contea"
                    [attr.aria-invalid]="
                      getAddressGroup(0)?.get('province')?.invalid &&
                      getAddressGroup(0)?.get('province')?.touched
                    "
                    [attr.aria-describedby]="
                      getAddressGroup(0)?.get('province')?.invalid &&
                      getAddressGroup(0)?.get('province')?.touched
                        ? 'province-error'
                        : null
                    "
                  />
                  <app-validation-error 
                    [control]="getAddressGroup(0)?.get('province') || null" 
                    errorId="province-error"
                    mode="alphanumeric"
                  />
                }
              </div>

              <div class="field col-12 md:col-6">
                <label for="municipality" class="font-semibold block mb-2">Città</label>
                @if (isItalySelected()) {
                  <p-select
                    inputId="municipality"
                    [options]="municipalityOptions()"
                    formControlName="municipality"
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Seleziona città"
                    styleClass="w-full"
                    [filter]="true"
                    filterPlaceholder="Cerca città"
                    showClear="true"
                    aria-label="Città"
                    [attr.aria-disabled]="isCityDisabled()"
                  >
                  </p-select>
                  @if (isCityDisabled()) {
                    <small class="text-color-secondary">Seleziona prima la provincia</small>
                  }
                } @else {
                  <input
                    pInputText
                    id="municipality"
                    formControlName="municipality"
                    class="w-full"
                    placeholder="Inserisci città"
                    aria-label="Città"
                    [attr.aria-invalid]="
                      getAddressGroup(0)?.get('municipality')?.invalid &&
                      getAddressGroup(0)?.get('municipality')?.touched
                    "
                    [attr.aria-describedby]="
                      getAddressGroup(0)?.get('municipality')?.invalid &&
                      getAddressGroup(0)?.get('municipality')?.touched
                        ? 'municipality-error'
                        : null
                    "
                  />
                  <app-validation-error 
                    [control]="getAddressGroup(0)?.get('municipality') || null" 
                    errorId="municipality-error"
                    mode="name"
                  />
                }
              </div>


              <div class="field col-12 md:col-6">
                <label for="country" class="font-semibold block mb-2">Stato</label>
                <p-select
                  inputId="country"
                  [options]="countryOptions()"
                  formControlName="country"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Seleziona stato"
                  styleClass="w-full"
                  [filter]="true"
                  filterPlaceholder="Cerca stato"
                  showClear="true"
                  aria-label="Stato"
                >
                </p-select>
              </div>



            </ng-container>
          </div>
        </section>

        <div
          class="actions flex flex-column gap-2 mt-5 align-items-end"
          role="group"
          aria-label="Azioni form"
        >
          @if (step1Form.invalid) {
            <small class="text-color-secondary" role="status" aria-live="polite">
              <i class="pi pi-info-circle mr-1" aria-hidden="true"></i>
              Completa tutti i campi obbligatori per proseguire
            </small>
          }
          <div class="flex gap-2">
            <p-button
              label="Salva Bozza"
              icon="pi pi-save"
              [outlined]="true"
              styleClass="btn-draft"
              (onClick)="saveDraft()"
              aria-label="Salva come bozza senza validazione"
              title="Salva i dati correnti come bozza"
            ></p-button>
            <p-button
              label="Salva e Prosegui"
              icon="pi pi-arrow-right"
              iconPos="right"
              type="submit"
              severity="primary"
              aria-label="Salva e prosegui allo step successivo"
              title="Salva i dati e passa allo step successivo"
            ></p-button>
          </div>
        </div>
      </form>
    }

    <!-- ================= STEP 2 ================= -->
    @if (wizardStepService.currentStep() === 1) {
      <!-- Breadcrumb / Back navigation -->
      <div class="mb-3">
        <p-button
          label="Torna al Registro"
          icon="pi pi-arrow-left"
          [outlined]="true"
          (onClick)="navigateToRegister()"
          [attr.aria-label]="'Torna al Registro Fornitori'"
          title="Torna al Registro Fornitori"
        ></p-button>
      </div>

      <!-- Page Header -->
      <section class="page-header mb-5" aria-labelledby="page-heading-step2">
        <div class="header-content">
          <div class="header-left">
            <i class="pi pi-file-edit header-icon" aria-hidden="true"></i>
            <div class="header-text">
              <h1 id="page-heading-step2">Dettagli Anagrafica Fornitore</h1>
              <p class="subtitle">Completa la registrazione con i dettagli del fornitore</p>
            </div>
          </div>
        </div>
      </section>

      <form [formGroup]="step2Form" (ngSubmit)="saveFinal()" class="p-fluid">
        <!-- Sezione Dettagli -->
        <section
          class="surface-0 border-round p-5 mb-4 shadow-1"
          aria-labelledby="dettagli-heading"
        >
          <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
            <i class="pi pi-file-edit text-2xl section-icon" aria-hidden="true"></i>
            <h2 id="dettagli-heading" class="text-xl font-semibold m-0 section-title">
              Dettagli Fornitore
            </h2>
          </div>

          <div class="grid">
            <div class="field col-12 md:col-6">
              <label for="codeAlboSOL" class="font-semibold block mb-2">Codice Albo SOL</label>
              <input
                pInputText
                id="codeAlboSOL"
                formControlName="codeAlboSOL"
                class="w-full"
                placeholder="Inserisci codice albo SOL"
                aria-label="Codice Albo SOL - campo opzionale"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="codeSupplierCoupa" class="font-semibold block mb-2"
                >Codice Supplier Coupa</label
              >
              <input
                pInputText
                id="codeSupplierCoupa"
                formControlName="codeSupplierCoupa"
                class="w-full"
                placeholder="Inserisci codice supplier Coupa"
                aria-label="Codice Supplier Coupa - campo opzionale"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="coupaAuthor" class="font-semibold block mb-2"
                >Autore inserimento Coupa</label
              >
              <input
                pInputText
                id="coupaAuthor"
                formControlName="coupaAuthor"
                class="w-full"
                placeholder="Nome dell'autore"
                aria-label="Autore inserimento Coupa - campo opzionale"
              />
            </div>

            <div class="field col-12 md:col-6">
              <label for="codeSupplierBravoSolution" class="font-semibold block mb-2"
                >Supplier Bravo Solution</label
              >
              <input
                pInputText
                id="codeSupplierBravoSolution"
                formControlName="codeSupplierBravoSolution"
                class="w-full"
                placeholder="Inserisci codice supplier Bravo"
                aria-label="Supplier Bravo Solution - campo opzionale"
              />
            </div>
          </div>
        </section>

        <div
          class="actions flex gap-2 mt-5 justify-content-between"
          role="group"
          aria-label="Azioni form step 2"
        >
          <p-button
            label="Indietro"
            icon="pi pi-arrow-left"
            [outlined]="true"
            (onClick)="goBack()"
            aria-label="Torna allo step precedente Anagrafica"
            title="Torna allo step precedente: Anagrafica"
          ></p-button>
          <div class="flex gap-2">
            <p-button
              label="Salva Bozza"
              icon="pi pi-save"
              [outlined]="true"
              styleClass="btn-draft"
              (onClick)="saveDraft()"
              aria-label="Salva i dettagli come bozza senza validazione"
              title="Salva i dettagli correnti come bozza"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              iconPos="right"
              severity="primary"
              type="submit"
              aria-label="Completa la registrazione del fornitore e torna al registro"
              title="Completa la registrazione del fornitore"
            ></p-button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
